import React, { createContext, useCallback, useContext, useState } from "react";
import HelpModal from "header/components/HelpModal/HelpModal";

const OpenTicketContext = createContext({
  openTicket: false,
  toggleOpenTicket: () => {},
});

export const OpenTicketProvider: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => {
  const [openTicket, setOpenTicket] = useState(false);

  const toggleOpenTicket = useCallback(() => {
    setOpenTicket(!openTicket);
  }, [openTicket]);

  return (
    <OpenTicketContext.Provider value={{ openTicket, toggleOpenTicket }}>
      {children}
      <HelpModal isOpen={openTicket} onClose={toggleOpenTicket} />
    </OpenTicketContext.Provider>
  );
};

export const useOpenTicket = () => useContext(OpenTicketContext);
